import { useSession } from "contexts/session-context"
import { useRouteMatch } from "react-router-dom"
import useMainClass from "hooks/use-main-cass"
import { dlTrackEvent } from "components/dataLayer/dataLayer"
import useRouter from "hooks/use-router"
import CheckpointOnBoarding from "./components/CheckpointOnBoarding"
import CheckpointPrize from "./components/CheckpointPrize"

function Checkpoint() {
  useMainClass('checkpoint')
  const [{ user }] = useSession()
  const { history } = useRouter()
  const route = useRouteMatch<{ id: string }>()

  const handleClick = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Checkpoint - Comencemos', value: '10' })
    dlTrackEvent('user_interaction', { action: 'click', element: 'comencemos', section: 'checkpoint' })
    localStorage.setItem('internal_redirect', `/checkpoint/qr/${route.params.id}`)
    return history.push('/start')
  }

  if (!user) {
    return <CheckpointOnBoarding handleClick={handleClick} />
  }

  return (<CheckpointPrize id={route.params.id} />)
}

export default Checkpoint